'use strict';
import React from 'react';
import {Link} from 'react-router';
import flux from 'utils/flux';

var ShareSidebar = React.createClass({

    displayName: 'ShareSidebar',

    propTypes: {
        baskets: React.PropTypes.object.isRequired,
        shareId: React.PropTypes.string
    },

    render() {
        var baskets = this.props.baskets.toJS();
        var user = this.props.user.toJS();

        return (
            <div className="share__sidebar">
                <div className="sidebar__user">
                    {user.firstName}<br /><span className="user__email">({user.email})</span><br />
                    {flux.t('share_selections_with')}
                </div>
                <ul className="sidebar__menu">
                    {baskets.map( basket => {
                        return (
                            <li key={basket.id} className="menu__item">
                                <Link className="item__link" to='shared' params={{ shareId: this.props.shareId, basketId: basket.id }}>
                                    {basket.name} ({basket.items.length})
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
});

module.exports = ShareSidebar;



// WEBPACK FOOTER //
// ./app/pages/share/shareSidebar.jsx